// import React, { useEffect, useState } from 'react';
// import { openDB } from 'idb';

// const Downloads = () => {
//     const [downloadedFiles, setDownloadedFiles] = useState([]);

//     console.log(downloadedFiles);


//     // Initialize IndexedDB
//     const initDB = async () => {
//         const db = await openDB('AudioDB', 1, {
//             upgrade(db) {
//                 if (!db.objectStoreNames.contains('audioFiles')) {
//                     db.createObjectStore('audioFiles');
//                 }
//             }
//         });
//         return db;
//     };

//     // Fetch all downloaded files from IndexedDB
//     const fetchDownloadedFiles = async () => {
//         const db = await initDB();
//         const keys = await db.getAllKeys('audioFiles');
//         const files = await Promise.all(keys.map(key => db.get('audioFiles', key)));

//         const fileData = keys.map((key, index) => ({
//             id: key,
//             blob: files[index]?.blob, // Accessing blob safely
//             name: files[index]?.name,
//             type: files[index]?.type,
//              // If you also stored the question
//         }));
//         setDownloadedFiles(fileData);
//     };

//     // Delete file from IndexedDB and update localStorage
//     const deleteFile = async (id) => {
//         const db = await initDB();
//         await db.delete('audioFiles', id);

//         // Update localStorage
//         const downloadedFilesFromStorage = JSON.parse(localStorage.getItem('downloadedFiles')) || {};
//         delete downloadedFilesFromStorage[id]; // Remove the deleted file ID
//         localStorage.setItem('downloadedFiles', JSON.stringify(downloadedFilesFromStorage));

//         fetchDownloadedFiles(); // Refresh the list after deletion
//     };

//     useEffect(() => {
//         fetchDownloadedFiles();
//     }, []);

//     return (
//         <div className="w-11/12 lg:w-11/12 mx-auto mt-16 relative">
//             <h1 className="text-xl border-b-4 border-accent font-bold mt-8 inline-block">
//                 Downloaded Audio Files
//             </h1>
//             <div className="mt-4">
//                 {downloadedFiles.length > 0 ? (
//                     downloadedFiles.map((file, index) => (
//                         <div
//                             key={file.id}
//                             className="shadow-xl bg-white hover:shadow-accent active:shadow-red-400 p-5 rounded-r-3xl rounded-tl-3xl text-left relative mb-2"
//                         >
//                            <div className='flex justify-between'>
//                            <h3 className="text-sm font-bold">
//                                 {file.type} {index + 1}: {file.name || `ID: ${file.id}`}
//                             </h3>
//                             {file.blob ? ( // Check if blob exists before rendering audio
//                                 // <audio controls className="mt-2 w-full">
//                                 //     <source src={URL.createObjectURL(file.blob)} type="audio/mpeg" />
//                                 //     Your browser does not support the audio tag.
//                                 // </audio>
//                                 ""
//                             ) : (
//                                 <p className="text-red-500">Failed to load audio file.</p> // Display error if blob is invalid
//                             )}
//                             <button
//                                 onClick={() => deleteFile(file.id)}
//                                 className="btn btn-error btn-xs text-white mt-2"
//                             >
//                                 X
//                             </button>
//                            </div>
//                         </div>
//                     ))
//                 ) : (
//                     <p>No downloaded files available.</p>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default Downloads;



// import React, { useEffect, useState } from 'react';
// import { openDB } from 'idb';

// const Downloads = () => {
//     const [downloadedFiles, setDownloadedFiles] = useState([]);
//     const [filteredFiles, setFilteredFiles] = useState([]);
//     const [fileTypeFilter, setFileTypeFilter] = useState(''); // Filter state, initially empty

//     // Initialize IndexedDB
//     const initDB = async () => {
//         const db = await openDB('AudioDB', 1, {
//             upgrade(db) {
//                 if (!db.objectStoreNames.contains('audioFiles')) {
//                     db.createObjectStore('audioFiles');
//                 }
//             }
//         });
//         return db;
//     };

//     // Fetch all downloaded files from IndexedDB
//     const fetchDownloadedFiles = async () => {
//         const db = await initDB();
//         const keys = await db.getAllKeys('audioFiles');
//         const files = await Promise.all(keys.map(key => db.get('audioFiles', key)));

//         const fileData = keys.map((key, index) => ({
//             id: key,
//             blob: files[index]?.blob, // Accessing blob safely
//             name: files[index]?.name,
//             type: files[index]?.type,
//         }));

//         setDownloadedFiles(fileData);

//         // Automatically set the first file type as the filter
//         if (fileData.length > 0) {
//             const uniqueFileTypes = [...new Set(fileData.map(file => file.type))];
//             setFileTypeFilter(uniqueFileTypes[0]); // Set the first type as default
//             filterByType(uniqueFileTypes[0], fileData); // Filter the files based on the first type
//         }
//     };

//     // Filter files by type
//     const filterByType = (type, files = downloadedFiles) => {
//         setFileTypeFilter(type); // Set the filter state
//         const filtered = files.filter(file => file.type === type);
//         setFilteredFiles(filtered); // Show only the files of the selected type
//     };

//     // Delete file from IndexedDB and update localStorage
//     const deleteFile = async (id) => {
//         const db = await initDB();
//         await db.delete('audioFiles', id);

//         // Update localStorage
//         const downloadedFilesFromStorage = JSON.parse(localStorage.getItem('downloadedFiles')) || {};
//         delete downloadedFilesFromStorage[id]; // Remove the deleted file ID
//         localStorage.setItem('downloadedFiles', JSON.stringify(downloadedFilesFromStorage));

//         fetchDownloadedFiles(); // Refresh the list after deletion
//     };

//     useEffect(() => {
//         fetchDownloadedFiles();
//     }, []);

//     // Extract unique file types for filtering buttons (no duplicates)
//     const uniqueFileTypes = [...new Set(downloadedFiles.map(file => file.type))];

//     return (
//         <div className="w-11/12 lg:w-11/12 mx-auto mt-16 relative">
//             <h1 className="text-xl border-b-4 border-accent font-bold mt-8 inline-block">
//                 ডাউনলোড করা ফাইলস
//             </h1>

//             {/* Centered Filter Group Buttons */}
//             <div className="flex justify-center items-center mt-4">
//                 <div className="btn-group">
//                     {uniqueFileTypes.map((type, index) => (
//                         <button
//                             key={index}
//                             onClick={() => filterByType(type)}
//                             className={`btn btn-sm ${fileTypeFilter === type ? 'btn-secondary' : 'btn-accent'} mx-1`}
//                         >
//                             {type}
//                         </button>
//                     ))}
//                 </div>
//             </div>

//             {/* Displaying Files */}
//             <div className="mt-4">
//                 {filteredFiles.length > 0 ? (
//                     filteredFiles.map((file, index) => (
//                         <div
//                             key={file.id}
//                             className="shadow-xl bg-white hover:shadow-accent active:shadow-red-400 p-5 rounded-r-3xl rounded-tl-3xl text-left relative mb-2"
//                         >
//                             <div className='flex justify-between'>
//                                 <h3 className="text-sm font-bold">
//                                     {file.type} {index + 1}: {file.name || `ID: ${file.id}`}
//                                 </h3>
//                                 {file.blob ? (
//                                     ""
//                                     // Uncomment this if you want audio playback:
//                                     // <audio controls className="mt-2 w-full">
//                                     //     <source src={URL.createObjectURL(file.blob)} type="audio/mpeg" />
//                                     //     Your browser does not support the audio tag.
//                                     // </audio>
//                                 ) : (
//                                     <p className="text-red-500">Failed to load audio file.</p>
//                                 )}
//                                 <button
//                                     onClick={() => deleteFile(file.id)}
//                                     className="btn btn-error btn-xs text-white mt-2"
//                                 >
//                                     X
//                                 </button>
//                             </div>
//                         </div>
//                     ))
//                 ) : (
//                     <p>No downloaded files available.</p>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default Downloads;


// import React, { useEffect, useState } from 'react';
// import { openDB } from 'idb';

// const Downloads = ({ setAudioDataOffline }) => {
//     const [downloadedFiles, setDownloadedFiles] = useState([]);
//     const [filteredFiles, setFilteredFiles] = useState([]);
//     const [fileTypeFilter, setFileTypeFilter] = useState(''); // Filter state, initially empty

//     // Initialize IndexedDB
//     const initDB = async () => {
//         const db = await openDB('AudioDB', 1, {
//             upgrade(db) {
//                 if (!db.objectStoreNames.contains('audioFiles')) {
//                     db.createObjectStore('audioFiles');
//                 }
//             }
//         });
//         return db;
//     };

//     // Fetch all downloaded files from IndexedDB
//     const fetchDownloadedFiles = async () => {
//         const db = await initDB();
//         const keys = await db.getAllKeys('audioFiles');
//         const files = await Promise.all(keys.map(key => db.get('audioFiles', key)));

//         const fileData = keys.map((key, index) => ({
//             id: key,
//             blob: files[index]?.blob, // Accessing blob safely
//             name: files[index]?.name,
//             type: files[index]?.type,
//         }));

//         setDownloadedFiles(fileData);

//         // Automatically set the first file type as the filter
//         if (fileData.length > 0) {
//             const uniqueFileTypes = [...new Set(fileData.map(file => file.type))];
//             setFileTypeFilter(uniqueFileTypes[0]); // Set the first type as default
//             filterByType(uniqueFileTypes[0], fileData); // Filter the files based on the first type
//         }
//     };

//     // Filter files by type
//     const filterByType = (type, files = downloadedFiles) => {
//         setFileTypeFilter(type); // Set the filter state
//         const filtered = files.filter(file => file.type === type);
//         setFilteredFiles(filtered); // Show only the files of the selected type
//     };

//     // Delete file from IndexedDB and update localStorage
//     const deleteFile = async (id) => {
//         const db = await initDB();
//         await db.delete('audioFiles', id);

//         // Update localStorage
//         const downloadedFilesFromStorage = JSON.parse(localStorage.getItem('downloadedFiles')) || {};
//         delete downloadedFilesFromStorage[id]; // Remove the deleted file ID
//         localStorage.setItem('downloadedFiles', JSON.stringify(downloadedFilesFromStorage));

//         fetchDownloadedFiles(); // Refresh the list after deletion
//     };

//     useEffect(() => {
//         fetchDownloadedFiles();
//     }, []);

//     // Extract unique file types for filtering buttons (no duplicates)
//     const uniqueFileTypes = [...new Set(downloadedFiles.map(file => file.type))];

//     const handlePlayAudio = (file) => {
//         const audioUrl = URL.createObjectURL(file.blob);
//         setAudioDataOffline({ link: audioUrl, name: file.name });
//     };

//     return (
//         <div className="w-11/12 lg:w-11/12 mx-auto mt-16 mb-20 relative">
//             <h1 className="text-xl border-b-4 border-accent font-bold mt-8 inline-block">
//                 Downloaded Audio Files
//             </h1>

//             {/* Centered Filter Group Buttons */}
//             <div className="flex justify-center items-center mt-4">
//                 <div className="btn-group">
//                     {uniqueFileTypes.map((type, index) => (
//                         <button
//                             key={index}
//                             onClick={() => filterByType(type)}
//                             className={`btn ${fileTypeFilter === type ? 'btn-primary' : 'btn-secondary'} mx-1`}
//                         >
//                             {type}
//                         </button>
//                     ))}
//                 </div>
//             </div>

//             {/* Displaying Files */}
//             <div className="mt-4">
//                 {filteredFiles.length > 0 ? (
//                     filteredFiles.map((file, index) => (
//                         <div

//                             key={file.id}
//                             className="shadow-xl bg-white hover:shadow-accent active:shadow-red-400 p-5 rounded-r-3xl rounded-tl-3xl text-left relative mb-2"
//                         >
//                             <div className='flex justify-between items-center'>
//                                 <label onClick={() => handlePlayAudio(file)} htmlFor="my-modal-7" className='flex items-center'>
//                                     <h3 className="text-sm font-bold">
//                                         {file.type} {index + 1}: {file.name || `ID: ${file.id}`}
//                                     </h3>
//                                 </label>

//                                 {file.blob ? (
//                                     ""
//                                 ) : (
//                                     <p className="text-red-500">Failed to load audio file.</p>
//                                 )}

//                                 <button
//                                     onClick={() => deleteFile(file.id)}
//                                     className="btn btn-error btn-xs text-white mt-2"
//                                 >
//                                     X
//                                 </button>
//                             </div>
//                         </div>
//                     ))
//                 ) : (
//                     <p>No downloaded files available.</p>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default Downloads;



import React, { useEffect, useState } from 'react';
import { openDB } from 'idb';
// Import FontAwesome icons (or use any other icon library)
import { FaPlay, FaWaveSquare } from 'react-icons/fa';
import OfflineAudioPlayer from '../Shared/OfflineAudioPlayer/OfflineAudioPlayer';

const Downloads = ({ setAudioDataOffline }) => {
    const [downloadedFiles, setDownloadedFiles] = useState([]);
    const [filteredFiles, setFilteredFiles] = useState([]);
    const [fileTypeFilter, setFileTypeFilter] = useState(''); // Filter state, initially empty
    const [currentlyPlayingId, setCurrentlyPlayingId] = useState(null); // Track currently playing file
    const [playingPlaylist, setPlayingPlaylist] = useState([]);

    // Initialize IndexedDB
    const initDB = async () => {
        const db = await openDB('AudioDB', 1, {
            upgrade(db) {
                if (!db.objectStoreNames.contains('audioFiles')) {
                    db.createObjectStore('audioFiles');
                }
            }
        });
        return db;
    };

    // Fetch all downloaded files from IndexedDB
    const fetchDownloadedFiles = async () => {
        const db = await initDB();
        const keys = await db.getAllKeys('audioFiles');
        const files = await Promise.all(keys.map(key => db.get('audioFiles', key)));

        const fileData = keys.map((key, index) => ({
            id: key,
            blob: files[index]?.blob, // Accessing blob safely
            name: files[index]?.name,
            type: files[index]?.type,
        }));

        setDownloadedFiles(fileData);

        // Automatically set the first file type as the filter
        if (fileData.length > 0) {
            const uniqueFileTypes = [...new Set(fileData.map(file => file.type))];
            setFileTypeFilter(uniqueFileTypes[0]); // Set the first type as default
            filterByType(uniqueFileTypes[0], fileData); // Filter the files based on the first type
        }
    };

    // Filter files by type
    const filterByType = (type, files = downloadedFiles) => {
        setFileTypeFilter(type); // Set the filter state
        const filtered = files.filter(file => file.type === type);
        setFilteredFiles(filtered); // Show only the files of the selected type
    };

    // Delete file from IndexedDB and update localStorage
    const deleteFile = async (id) => {
        const db = await initDB();
        await db.delete('audioFiles', id);

        // Update localStorage
        const downloadedFilesFromStorage = JSON.parse(localStorage.getItem('downloadedFiles')) || {};
        delete downloadedFilesFromStorage[id]; // Remove the deleted file ID
        localStorage.setItem('downloadedFiles', JSON.stringify(downloadedFilesFromStorage));

        fetchDownloadedFiles(); // Refresh the list after deletion
    };

    useEffect(() => {
        fetchDownloadedFiles();
    }, []);

    // Extract unique file types for filtering buttons (no duplicates)
    const uniqueFileTypes = [...new Set(downloadedFiles.map(file => file.type))];

    const handlePlayAudio = (file) => {
        const audioUrl = URL.createObjectURL(file.blob);
        setAudioDataOffline('play')
        // setAudioDataOffline({ link: audioUrl, name: file.name });
        setCurrentlyPlayingId(file.id); // Mark the current file as playing
        setPlayingPlaylist(filteredFiles);
    };

    return (
        <div className="w-11/12 lg:w-11/12 mx-auto mt-16 mb-20 relative">
            <h1 className="text-xl border-b-4 border-accent font-bold mt-8 inline-block">
                Downloaded Audio Files
            </h1>

            {/* Centered Filter Group Buttons */}
            <div className="flex justify-center items-center mt-4">
                <div className="btn-group">
                    {uniqueFileTypes.map((type, index) => (
                        <button
                            key={index}
                            onClick={() => filterByType(type)}
                            className={`btn ${fileTypeFilter === type ? 'btn-primary' : 'btn-secondary'} mx-1`}
                        >
                            {type}
                        </button>
                    ))}
                </div>
            </div>

            {/* Displaying Files */}
            <div className="mt-4">
                {filteredFiles.length > 0 ? (
                    filteredFiles.map((file, index) => (
                        <div
                            key={file.id}
                            className="shadow-xl bg-white hover:shadow-accent active:shadow-red-400 p-5 rounded-r-3xl rounded-tl-3xl text-left relative mb-2"
                        >
                            <div className='flex justify-between items-center'>
                                {/* Audio Icon or Animation for Playing Audio */}
                                <div
                                    className={`w-12 h-12 flex justify-center items-center p-3 rounded bg-gray-200 mr-3`}
                                >
                                    {currentlyPlayingId === file.id ? (
                                        // Show animation if file is playing
                                        <FaWaveSquare className="text-gray-600 animate-pulse" />
                                    ) : (
                                        // Default gray play icon
                                        <FaPlay className="text-gray-600" />
                                    )}
                                </div>

                                <label onClick={() => handlePlayAudio(file)} htmlFor="my-modal-7" className='flex items-center'>
                                    <h3 className="text-sm font-bold">
                                        {file.type} {index + 1}: {file.name || `ID: ${file.id}`}
                                    </h3>
                                </label>

                                {file.blob ? (
                                    ""
                                ) : (
                                    <p className="text-red-500">Failed to load audio file.</p>
                                )}

                                <button
                                    onClick={() => deleteFile(file.id)}
                                    className="btn btn-error btn-xs text-white mt-2"
                                >
                                    X
                                </button>
                            </div>
                        </div>
                    ))
                ) : (
                    <p>No downloaded files available.</p>
                )}
            </div>
            {/* Render the OfflineAudioPlayer and pass the playlist */}
            <OfflineAudioPlayer setAudioDataOffline={setAudioDataOffline} currentlyPlayingId={currentlyPlayingId} setCurrentlyPlayingId={setCurrentlyPlayingId} playlist={playingPlaylist} />
        </div>
    );
};

export default Downloads;





// import React, { useEffect, useState } from 'react';
// import { openDB } from 'idb';
//  // Import OfflineAudioPlayer

// const Downloads = ({ setAudioDataOffline }) => {
//     const [downloadedFiles, setDownloadedFiles] = useState([]);
//     const [filteredFiles, setFilteredFiles] = useState([]);
//     const [fileTypeFilter, setFileTypeFilter] = useState('');
//     const [currentlyPlayingId, setCurrentlyPlayingId] = useState(null);
//      // Playlist for audio player

//     // Initialize IndexedDB and fetch files
//     const initDB = async () => {
//         const db = await openDB('AudioDB', 1, {
//             upgrade(db) {
//                 if (!db.objectStoreNames.contains('audioFiles')) {
//                     db.createObjectStore('audioFiles');
//                 }
//             }
//         });
//         return db;
//     };

//     const fetchDownloadedFiles = async () => {
//         const db = await initDB();
//         const keys = await db.getAllKeys('audioFiles');
//         const files = await Promise.all(keys.map(key => db.get('audioFiles', key)));

//         const fileData = keys.map((key, index) => ({
//             id: key,
//             blob: files[index]?.blob,
//             name: files[index]?.name,
//             type: files[index]?.type,
//         }));

//         setDownloadedFiles(fileData);

//         if (fileData.length > 0) {
//             const uniqueFileTypes = [...new Set(fileData.map(file => file.type))];
//             setFileTypeFilter(uniqueFileTypes[0]);
//             filterByType(uniqueFileTypes[0], fileData);
//         }
//     };

//     const filterByType = (type, files = downloadedFiles) => {
//         setFileTypeFilter(type);
//         const filtered = files.filter(file => file.type === type);
//         setFilteredFiles(filtered);
//     };

//     const handlePlayAudio = (file) => {
//         const audioUrl = URL.createObjectURL(file.blob);
//         setAudioDataOffline({ link: audioUrl, name: file.name });
//         setCurrentlyPlayingId(file.id);
//         setPlayingPlaylist(filteredFiles); // Set the current playlist based on filtered files
//     };

//     useEffect(() => {
//         fetchDownloadedFiles();
//     }, []);

//     const uniqueFileTypes = [...new Set(downloadedFiles.map(file => file.type))];

//     return (
//         <div className="w-11/12 lg:w-11/12 mx-auto mt-16 mb-20 relative">
//             <h1 className="text-xl border-b-4 border-accent font-bold mt-8 inline-block">
//                 Downloaded Audio Files
//             </h1>

//             <div className="flex justify-center items-center mt-4">
//                 <div className="btn-group">
//                     {uniqueFileTypes.map((type, index) => (
//                         <button
//                             key={index}
//                             onClick={() => filterByType(type)}
//                             className={`btn ${fileTypeFilter === type ? 'btn-primary' : 'btn-secondary'} mx-1`}
//                         >
//                             {type}
//                         </button>
//                     ))}
//                 </div>
//             </div>

//             <div className="mt-4">
//                 {filteredFiles.length > 0 ? (
//                     filteredFiles.map((file, index) => (
//                         <div
//                             key={file.id}
//                             className="shadow-xl bg-white hover:shadow-accent active:shadow-red-400 p-5 rounded-r-3xl rounded-tl-3xl text-left relative mb-2"
//                         >
//                             <div className='flex justify-between items-center'>
//                                 <div
//                                     className={`w-12 h-12 flex justify-center items-center p-3 rounded bg-gray-200 mr-3`}
//                                 >
//                                     {currentlyPlayingId === file.id ? (
//                                         <span className="text-gray-600 animate-pulse">Playing</span>
//                                     ) : (
//                                         <span className="text-gray-600">Play</span>
//                                     )}
//                                 </div>

//                                 <label onClick={() => handlePlayAudio(file)} htmlFor="my-modal-7" className='flex items-center'>
//                                     <h3 className="text-sm font-bold">
//                                         {file.type} {index + 1}: {file.name || `ID: ${file.id}`}
//                                     </h3>
//                                 </label>
//                             </div>
//                         </div>
//                     ))
//                 ) : (
//                     <p>No downloaded files available.</p>
//                 )}
//             </div>

//              />
//         </div>
//     );
// };

// export default Downloads;



